const DAY_MS = 24 * 60 * 60 * 1000;

const getStorageKey = (nudge) => `mfaNudge.${nudge}`;

const DECISION_KEY = 'mfaNudge.decision';

// Blocked or full storage (e.g. private browsing) is expected, not an error: nudges then last
// only for the page load.
function tryStorage(action, fallback) {
  try {
    return action();
  } catch {
    return fallback;
  }
}

export function isMfaNudgeHidden(nudge) {
  const stored = tryStorage(() => JSON.parse(localStorage.getItem(getStorageKey(nudge))), null);
  return Boolean(stored?.dismissed) || (stored?.snoozedUntil ?? 0) > Date.now();
}

function writeMfaNudge(nudge, value) {
  tryStorage(() => localStorage.setItem(getStorageKey(nudge), JSON.stringify(value)));
}

export function snoozeMfaNudge(nudge, days) {
  writeMfaNudge(nudge, { snoozedUntil: Date.now() + days * DAY_MS });
}

export function dismissMfaNudge(nudge) {
  writeMfaNudge(nudge, { dismissed: true });
}

export function readMfaNudgeDecision(userUuid) {
  const stored = tryStorage(() => JSON.parse(sessionStorage.getItem(DECISION_KEY)), null);
  return stored && stored.userUuid === userUuid ? stored.nudge : undefined;
}

export function saveMfaNudgeDecision(userUuid, nudge) {
  tryStorage(() => sessionStorage.setItem(DECISION_KEY, JSON.stringify({ userUuid, nudge })));
}

export function clearMfaNudgeDecision() {
  tryStorage(() => sessionStorage.removeItem(DECISION_KEY));
}
